import enLocale from "element-ui/lib/locale/lang/en";

export default {
  ...enLocale,
  main: {
    title: "CQTC | One-Stop Service",
    submit: "Submit",
    more: "More",
    welcome: "Welcome to Chongqing Telecommunications Vocational College!",
  },
  user: {
    morning: "Good morning",
    noon: "Good noon",
    afternoon: "Good afternoon",
    evening: "Good evening",
  },
  mobile: {
    accountName: "Account",
    inputAccount: "Please enter account",
    inputPwd: "Please enter password",
    verificationCode: "Code",
    inputCode: "Please enter code",
    inputSearch: "Please enter search",
    commonList: "Common list",
    appCenter: "App center",
    moreService: "Log in to enjoy more personalized services",
    toLogin: "Login",
    MessageDetail: "Message detail",
    selectLanguage: "select language",
    home: {
      welcome: "Welcome to",
      school: "CQTC",
      myApps: "My Apps",
      news: "News",
      informations: "Informations",
      collection: "Collection",
      accounts: "Accounts",
      messages: "Messages",
    },
    profile: {
      head: "Head",
      name: "Name",
      bindEmail: "Bind Email",
      bindAccount: "Bind Account",
      bindPhone: "Bind Phone",
      loginLogs: "Login Logs",
      selectDate: "Select Date Range",
      close: "Close",
      startDate: "Start Date",
      endDate: "End Date",
      confirm: "Confirm",
      appRecords: "App Records",
      accountRecords: "Account Records",
      passwordRecords: "Password Records",
      security: "Security",
      time: "Time",
      status: "Status",
      successful: "Successful",
      failed: "Failed",
      changeEmail: "Change Email",
      email: "Email",
      inputEmail: "Please enter email",
      imgCode: "Image Code",
      inputImgCode: "Please enter image code",
      emailCode: "Email Code",
      inputEmailCode: "Please enter email code",
      sendCode: "Send",
      reSend: "Send again in {key} s",
      confirmLogout: "Are you sure to log out?",
      confirm: "Confirm",
      cancel: "Cancel",
      trustDevice: "Trust/FIDO Device",
      subscription: "Subscription messages",
      trust: "Trust",
      isTrusted: "Is trusted device",
      deleteTrust: "Delete",
      Yes: "Yes",
      No: "No",
      changePhone: "Change Phone",
      phone: "Phone",
      inputPhone: "Please enter phone",
      phoneCode: "Phone Code",
      inputPhoneCode: "Please enter phone code",
    },
    account: {
      username: "account",
      inputUserName: "Please enter a account",
      bindNew: "Bind new account",
      save: "Save",
      unbind: "Unbind ?",
      default: "Default",
      main: "Current",
      bindSuccess: "Bind success",
    },
  },
  login: {
    welcome: "Welcome to DIA",
    wechat: "WeChat",
    dingding: "Ding Ding",
    account: "Account",
    login: "Login",
    activatiton: "Activation",
    appeal: "Appeal",
    inputPwd: "Please enter your password",
    inputAccount: "Please enter your account/phone ",
    inputCode: "Please enter the verification code",
    useWeChat: "Please scan the QR code with WeChat to log in",
    codeOutOfDate: "The verification code has expired, please ",
    refreshCode: "refresh",
    periodOfCode: "The validity period of the QR code",
    loginSuccess: "Login successful!",
    redirecting: "Redirecting...",
    getCodeFail: "Failed to get verification code",
    code: "Please enter the verification code",
    forgetPassword: "Forget password?",
    password: "Password",
    text1: "The disabled student alumni account can be reset by resetting the password",
    text2: "For first-time login, please click on 'Forgot Password' to reset it",
    text3: "It is strictly prohibited to transmit or handle state secrets on this non-classified Internet platform. Please confirm that the documents and materials scanned, uploaded, and processed do not involve state secrets",
  },
  menubar: {
    home: "Home",
    affairs: "Affairs",
    analysis: "Analysis",
    service: "Guide",
    systemEntries: "Systems",
    myAffairs: "My Affairs",
    search: "Search",
    message: "Messages",
    instructions: "Instructions",
    profile: "Profile",
    logout: "Logout",
    mine: "Mine",
    apps: "Apps",
  },
  home: {
    hi: "Hi !",
    welcome: "Welcome to CQTC!",
    inputKeyWord: "Please enter the key words",
    search: "Search",
    hotWord: "Hot words",
    service: "Recommendation services",
    stuProject: "Student projects",
    serviceDes:
      "Precise recommendation service, personalized matching, enhancing user experience.",
    viewMore: "More",
    system: "Recommendation systems",
    systemService: " services",
    departmentDes: " departments have moved in, ",
    total: "a total of ",
    refresh: "Refresh",
    specialized: "Specialized services",
    specializedDes:
      "Professional specialized services, in-depth analysis, to meet specific needs.",
    departmentService: "Department services",
    departmentServiceDes:
      "Direct department services, rapid response, and efficient problem-solving.",
    convenienceServices: "Convenience services",
    convenienceServicesDes:
      "Intimate convenience services, simplifying procedures and facilitating people's lives.",
    enter: "Enter",
    times: " times used",
  },
  footer: {
    vpnHotline: "VPN Service  Hotline:",
    passwordHotline: "Unified Authentication Password Modification Hotline:",
    networkHotline: "Network Fault Hotline:",
    emailHotline: "Email Account Opening Hotline:",
    stationHotline: "Station Group Maintenance Hotline:",
    accountHotline: "Campus Account Opening Hotline:",
    organizer: "Organizer: Chongqing Telecommunications Vocational College",
    address:
      "Address: No. 9, Bayue Avenue, Shuangqiao Economic Development Zone, Chongqing City",
    technical: "Technical Support: Information Center",
    suggestion:
      "We recommend that you use mainstream browsers such as IE9 and above, Edge, Chrome, Firefox and 360 to browse this website.",
    serviceAccount: "One-Stop Service Account",
    rights: "Copyright © Chongqing Telecommunications Vocational College",
  },
  affairs: {
    title: "Affairs Center",
    collapseSearh: "Collapse",
    expandSearh: "Expand",
    all: "All",
    matterType: "Matter Type:",
    handingChannel: "Handling Channel:",
    visiteCount: "Visit count: ",
    times: " times",
    banner: "Explore the world with more efficiency",
    searchMessage:
      '{count} pieces of information containing the character "{key}" have been found for you.',
  },
  analysis: {
    title: "Energy Efficiency Analysis",
    serviceEfficiency: "Service Efficiency",
    lastWeek: "Last week",
    lastMonth: "Last month",
    lastTreeMonth: "Last 3 months",
    lastYear: "Last year",
    rangeSeparator: "to",
    startPlaceholder: "Start Date",
    endPlaceholder: "End Date",
    search: "Search",
    reset: "Reset",
    serviceChart: "Service count trend chart",
    upTo: "Up to Last Natural Day",
    deptApproval: "Dept. approval participation times ",
    deptService: "Online service items of the department",
    serviceCount: "Service count ",
    student: "student",
    teacher: "teacher",
    visitor: "visitor",
    deptStats: "Stats by service object's dept. ",
    processApproval: "Process approval rate",
    ranking: "Ranking",
    name: "Name",
    overallProportion: "Overall proportion",
    processApprovalEfficiency: "Process approval efficiency",
    deptApprovalCount: "Dept. approval participation count",
    deptRanking:
      "Top Business Departments by Process Approval Counts (Dept. Dimension)",
  },
  guide: {
    title: "Service Guide",
    serviceRecipient: "Service Recipient:",
    matterNumber: "Matter Number",
    matterName: "Matter Name",
    matterType: "Matter Type",
    department: "Department",
    operations: "Operations",
    bookmark: "Bookmark",
    unbookmark: "Unbookmark",
    basicInfo: "Basic Information",
    handingProcess: "Handling Process",
    others: "Others",
    feedback: "Feedback",
    consultation: "Consultation",
    appointment: "Online Appointment",
    noOthers: "No other information available",
    method: "Method",
    handingChannel: "Handling Channel",
    hotline: "Hotline",
    supervision: "S.H",
    matterNature: "Matter Nature",
    handingTime: "Handling Time",
    handlingEntrance: "Handling Entrance",
  },
  systems: {
    title: "Common System Entries",
    department: "Department:",
    noPhone: "No phone",
  },
  myAffairs: {
    notification: "Notice",
    schoolNotice: "School",
    departmentNotice: "Department",
    service: "Common Services",
    systems: "Common Systems",
    guide: "Common Guides",
    messageCenter: "Message Center",
    schedule: "Schedule",
    read: "Read",
    unread: "Unread",
    completed: "Handled",
    uncompleted: "Unhandled",
    pending: "Pending",
    noticeTitle: "Notice Title:",
    noticeType: "Notice Type:",
    publishDept: "Publishing Department:",
    onlyUnread: "Only unread ",
    onlyFollow: "Only I follow",
    searchMessage: "We have found {count} pieces of information for you.",
    searchTitle: "Please input the announcement title",
    myToDo: "To-Do",
    myCompleted: "Completed",
    carbonCopy: "CC'd to me",
    myInitiated: "Initiated",
    drafts: "Drafts",
    fillingTask: "Filling Task",
    sharedWithMe: "Shared with Me",
    transferred: "Transferred",
    efficiencyData: "Efficiency Data",
    affairName: "Affair Name",
    searchHolder: "Please input",
    number: "No.",
    serviceSource: "Service Source",
    lastReceivedTime: "Last Received Time",
    personEntrusted: "Person Entrusted",
    options: "Options",
    details: "Details",
    noticeDetail: "Notice Detail",
    pendingDetail: "Pending Detail",
    keyWord: "keyWord",
    source: "source",
    dateRange: "dateRange",
    title: "标题",
    content: "内容",
    date: "日期",
    manage: "Manage",
  },
  profile: {
    myPhone: "My Phone",
    account: "Account",
    changePassword: "Change Password",
    logout: "Logout",
    setting: "Setting",
    security: "Security",
    thirdParty: "Third Party",
    monitor: "Monitor",
    bind: "Bind",
    securitySetting: "Security Setting",
    loginLogs: "Logs",
    gender: "Gender",
    idCard: "Resident ID Card",
    accountName: "Account Name",
    dentity: "Dentity",
    affiliation: "Affiliation",
    expiryDate: "Expiry Date",
    active: "Active",
    status: "Status",
    defaultAccount: "Default",
    operations: "Operations",
    cancelDefault: "Cancel",
    passwordSetting: "Please set a new password",
    pswSettingDes:
      "The password modified here is for the school's unified identity authentication, which also serves as the login password for this system.",
    oldPwd: "Old:",
    newPwd: "New:",
    confrmPwd: "Confirm:",
    studentStaffID: "Student/Staff ID",
    departName: "Department",
    myEmail: "	My Email",
    accbind: "Account Binding",
    iszhu: "Primary Account?",
    accountType: "Account Type",
    isDefault: "Default?",
    loginHistory: "Login History",
    handleDate: "Filter Date",
    startDate: "Start Date",
    endDate: "End Date",
    point: "points",
    browser: "Browser",
    os: "Operating System",
    loginWay: "Login Way",
    msg: "Prompt message",
    loginTime: "Login Time",
    goset: "Go Set",
    mibao: "Security Settings",
    setmibao: "Already Set",
    setnomibao: "Not Set",
    yibangding: "Bound",
    weibangding: "Go to Bind",
    quchakan: "Go View",
    phone: "Phone",
    securityScore: "Score",
    securityInfo: "Information",
    levelLow: "Low",
    levelNormal: "Average",
    levelGood: "Good",
    levelExcellent: "Excellent",
    levelAmazing: "Amazing",
    loginPassword: "Password",
    securityEmail: "Email",
    securityPhone: "Phone",
    setNow: "Set",
    changeNow: "Change",
    inputNewPwd: "Please enter new password",
    inputOldPwd: "Please enter old password",
    cannotBeSame: "The new password cannot be the same as the old one.",
    inputPwdAgain: "Please enter new password again",
    pwdNotSame: "The passwords entered twice were not the same.",
    passwordDesc:
      "Passwords should be at least 8 characters long and contain numbers, letters, and special characters.",
    emailDesc:
      "Your email will be your valid ID card, while also providing more convenient email reminders while ensuring security.",
    phoneDesc:
      "Safe phone numbers can be used for login, and if your phone number is lost or disabled, please change it immediately.",
    lowLevelDesc:
      "Your account security score is low, so we recommend that you strengthen your password and bind all security authentication methods.",
    cannotBeSame: "New password cannot be the same as old password",
    inputPwdAgain: "Please input password again",
    pwdNotSame: "Two input passwords are not the same",
    modifySuccess: "Modify Success",
    bindEmail: "Bind email",
    todayis: "Today is",
    welcome: "Welcome back",
    goGood: "Optimize",
    fengxian: "Account is highly secure. Keep current settings.",
    fengxian1: "Account at risk. Urgently update security info.",
    thirdPartyPage: {
      title: "Third Party Accounts",
      addAccount: "Add Account",
      accountName: "Account",
      password: "Password",
      appName: "Application",
      unbind: "Unbind",
    },
    monitorPage: {
      title: "Monitor Accounts",
      addAccount: "Add Monitor Account",
      accountName: "Account",
      loginAccount: "Login Account",
      operations: "Operations",
      delete: "delete",
    },
    bindPage: {
      title: "Bind Social Accounts",
      wechat: "WeChat",
      qq: "QQ",
      dingding: "DingTalk",
    },
    settingPage: {
      title: "Security Setting",
      question: "Question",
      answer: "Answer",
      addSecurity: "Add",
      operations: "Operations",
      change: "Change",
      delete: "Delete",
    },
    logsPage: {
      ip: "IP",
      time: "Time",
      location: "Location",
      device: "Device",
      logsDesc:
        "The following is a list of your recent login records. If you notice any suspicious activity, please contact the administrator immediately ",
      changePwd: "change password",
    },
  },
  search: {
    all: "All",
    affairs: "Affairs",
    specialized: "Specialized services",
    commonSystems: "Common Systems",
    serviceGuide: "Service Guide",
  },
};
